module.exports = __webpack_public_path__ + "static/media/colorbook-logo@2x.10dcc65d.png";